export default "__VITE_ASSET__$WyvX7hV__"